module.exports = __webpack_public_path__ + "img/upload-manually.88c585de.svg";